module.exports = __webpack_public_path__ + "static/media/visa.68352ae3.svg";